/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import { PolicyProvider } from '@Policy/store';
import React, { useCallback } from 'react';
import { useGmailHpuTargetUserGroups } from '@Policy/hooks';
import { SingleTargetUserGroups } from '@Policy/Components/SingleTargetUserGroups';
import { useOrgStore } from '@Models/useOrgModel';
import { useTranslation } from 'react-i18next';
import { getGmailTemplateConfig } from '@Policy/TemplateConfig/cfg.gmail';
import { useGlobalSettingStore } from '@Models/useGlobalSettingModel';

export const GmailTarget = React.forwardRef((_, ref) => {
  const { t } = useTranslation();
  const { selectedOrgGlobalSetting } = useGlobalSettingStore();
  const gmailTemplateData = getGmailTemplateConfig(
    t,
    selectedOrgGlobalSetting,
    ''
  );
  const TargetUserGroupsGmail = useCallback(() => {
    const props = useGmailHpuTargetUserGroups();
    return <SingleTargetUserGroups {...props} ref={ref} />;
  }, []);
  const configData = {};
  const { orgId } = useOrgStore();
  return (
    <PolicyProvider
      template={gmailTemplateData}
      config={configData}
      orgId={orgId}
    >
      <TargetUserGroupsGmail />
    </PolicyProvider>
  );
});
